import styled, { css } from 'styled-components';

export const FormItemContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const LabelContainer = styled.div`

`;

export const LabelWrapper = styled.div``;

interface ChildrenWrapperProps {
    itemRadius?: number;
}
export const ChildrenWrapper = styled.div<ChildrenWrapperProps>`
    width: 100%;
    max-width: 160px;
    display: flex;

    > * {
        border-radius: 0;
    }

    ${props => {
        if (props.itemRadius) {
            return css`
            > *:first-child {
                border-radius: ${props.itemRadius}px 0px 0px ${props.itemRadius}px;
            }
        
            > *:last-child {
                border-radius: 0px ${props.itemRadius}px ${props.itemRadius}px 0px;
            }
            `;
        } else {
            return css`
            > *:first-child {
                border-radius: 4px 0px 0px 4px;
            }
        
            > *:last-child {
                border-radius: 0px 4px 4px 0px;
            }
            `;
        }
    }}


`;